module.exports = __webpack_public_path__ + "img/store-lightspeed.f67062a7.svg";